import React from 'react';
import Styled from 'styled';

import defaultStyles, { ActionScss } from './action.scss';

export interface Props extends React.HTMLAttributes<HTMLButtonElement> {
    styles: ActionScss;
}

class Action extends React.PureComponent<Props> {
    render() {
        const { styles, ...rest } = this.props;

        return (
            <li className={styles.action}>
                <button {...rest} className={styles.button} />
            </li>
        );
    }
}

export default Styled(defaultStyles)(Action);
